"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _InfoInputsValueExampleOneOfInner = _interopRequireDefault(require("./InfoInputsValueExampleOneOfInner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * The InfoInputsValueExample model module.
 * @module model/InfoInputsValueExample
 * @version 1.0.0
 */
var InfoInputsValueExample = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>InfoInputsValueExample</code>.
   * @alias module:model/InfoInputsValueExample
   * @param {(module:model/Boolean|module:model/Number|module:model/String|module:model/[InfoInputsValueExampleOneOfInner])} instance The actual instance to initialize InfoInputsValueExample.
   */
  function InfoInputsValueExample() {
    var instance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, InfoInputsValueExample);
    _defineProperty(this, "toJSON", function () {
      return this.getActualInstance();
    });
    if (instance === null) {
      this.actualInstance = null;
      return;
    }
    var match = 0;
    var errorMessages = [];
    try {
      // validate array of string
      if (!(typeof instance === 'string')) {
        throw new Error("Invalid input. Must be string. Input: " + JSON.stringify(instance));
      }
      this.actualInstance = instance;
      match++;
    } catch (err) {
      // json data failed to deserialize into String
      errorMessages.push("Failed to construct String: " + err);
    }
    try {
      // JM: that condition was != instead of ==
      // validate array of string
      if (!(typeof instance === 'number' && instance % 1 == 0)) {
        throw new Error("Invalid array items. Must be number. Input: " + JSON.stringify(instance));
      }
      this.actualInstance = instance;
      match++;
    } catch (err) {
      // json data failed to deserialize into Number
      errorMessages.push("Failed to construct Number: " + err);
    }
    try {
      // JM: that condition code was missing, it made it crash.
      // validate array of boolean
      if (!(typeof instance === 'boolean')) {
        throw new Error("Invalid input. Must be boolean. Input: " + JSON.stringify(instance));
      }
      this.actualInstance = instance;
      match++;
    } catch (err) {
      // json data failed to deserialize into Boolean
      errorMessages.push("Failed to construct Boolean: " + err);
    }
    try {
      if (typeof instance === "[InfoInputsValueExampleOneOfInner]") {
        this.actualInstance = instance;
      } else {
        // plain JS object
        // validate the object
        [_InfoInputsValueExampleOneOfInner.default].validateJSON(instance); // throw an exception if no match
        // create [InfoInputsValueExampleOneOfInner] from JS object
        this.actualInstance = [_InfoInputsValueExampleOneOfInner.default].constructFromObject(instance);
      }
      match++;
    } catch (err) {
      // json data failed to deserialize into [InfoInputsValueExampleOneOfInner]
      errorMessages.push("Failed to construct [InfoInputsValueExampleOneOfInner]: " + err);
    }
    if (match > 1) {
      throw new Error("Multiple matches found constructing `InfoInputsValueExample` with oneOf schemas Boolean, Number, String, [InfoInputsValueExampleOneOfInner]. Input: " + JSON.stringify(instance));
    } else if (match === 0) {
      this.actualInstance = null; // clear the actual instance in case there are multiple matches
      throw new Error("No match found constructing `InfoInputsValueExample` with oneOf schemas Boolean, Number, String, [InfoInputsValueExampleOneOfInner]. Details: " + errorMessages.join(", "));
    } else {// only 1 match
      // the input is valid
    }
  }

  /**
   * Constructs a <code>InfoInputsValueExample</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InfoInputsValueExample} obj Optional instance to populate.
   * @return {module:model/InfoInputsValueExample} The populated <code>InfoInputsValueExample</code> instance.
   */
  _createClass(InfoInputsValueExample, [{
    key: "getActualInstance",
    value:
    /**
     * Gets the actual instance, which can be <code>Boolean</code>, <code>Number</code>, <code>String</code>, <code>[InfoInputsValueExampleOneOfInner]</code>.
     * @return {(module:model/Boolean|module:model/Number|module:model/String|module:model/[InfoInputsValueExampleOneOfInner])} The actual instance.
     */
    function getActualInstance() {
      return this.actualInstance;
    }

    /**
     * Sets the actual instance, which can be <code>Boolean</code>, <code>Number</code>, <code>String</code>, <code>[InfoInputsValueExampleOneOfInner]</code>.
     * @param {(module:model/Boolean|module:model/Number|module:model/String|module:model/[InfoInputsValueExampleOneOfInner])} obj The actual instance.
     */
  }, {
    key: "setActualInstance",
    value: function setActualInstance(obj) {
      this.actualInstance = InfoInputsValueExample.constructFromObject(obj).getActualInstance();
    }

    /**
     * Returns the JSON representation of the actual instance.
     * @return {string}
     */
  }], [{
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      return new InfoInputsValueExample(data);
    }
  }]);
  return InfoInputsValueExample;
}();
_defineProperty(InfoInputsValueExample, "fromJSON", function (json_string) {
  return InfoInputsValueExample.constructFromObject(JSON.parse(json_string));
});
InfoInputsValueExample.OneOf = ["Boolean", "Number", "String", "[InfoInputsValueExampleOneOfInner]"];
var _default = InfoInputsValueExample;
exports.default = _default;